import { Component, OnInit } from '@angular/core';
import { AuthService } from 'bnsights-utilities-library';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

 
  title = "Login";

  constructor(private authService:AuthService)
  {
    this.login();
  }
    
  login() {     
    this.authService.login();
  }   

  ngOnInit() {
   
  }

}
